<template>
  <!-- 帮助文档编辑 -->
  <div class="editDoc">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <!-- 表单 -->
    <el-scrollbar
      style="
        height: calc(100% - 60px);
        padding-top: 20px;
        box-sizing: border-box;
      "
    >
      <el-form
        :model="addForm"
        label-position="rigth"
        label-width="120px"
        :rules="addFormRule"
        ref="addForm"
      >
        <div class="form-item-warp">
          <el-form-item label="所属父类标题" prop="parentId">
            <el-select
              v-model="addForm.parentId"
              placeholder="所属父类标题"
              style="width: 200px"
            >
              <el-option
                v-for="(item, index) in parentList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item-warp">
          <el-form-item label="文章标题" prop="title">
            <el-input v-model="addForm.title" style="width: 200px"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-warp">
          <el-form-item label="排序值" prop="sort">
            <el-input-number
              v-model="addForm.sort"
              :min="1"
              style="width: 200px"
            ></el-input-number>
          </el-form-item>
        </div>
        <div class="form-item-warp">
          <el-form-item label="文章内容" prop="content">
            <!-- <wang-editor :value="addForm.content" @change="change" style="width:800px"></wang-editor> -->
            <tinymce
              :value="addForm.content"
              @input="change"
              :isEditorLoad="isEditorLoad"
              style="width: 800px"
            ></tinymce>
          </el-form-item>
        </div>
        <div class="form-item-wrap" style="margin-top: 20px">
          <el-form-item>
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button type="info" @click="resetForm">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>
  </div>
</template>

<script>
//组件
// import WangEditor from "@/components/WangEditor.vue";
import Tinymce from "@/components/Tinymce";
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "editDoc",
  data() {
    return {
      id: "",
      //新增表单
      addForm: {
        parentId: "", // 父级id
        title: "", // 文章标题
        sort: "", // 排序
        content: "", // 内容
      },
      addFormRule: {
        parentId: [mustFill],
        title: [mustFill],
        sort: [mustFill],
      },
      parentList: [],
      isEditorLoad: false, // 编辑器是否加载完成
    };
  },
  components: {
    Tinymce,
  },
  mounted() {
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if (prams) {
      this.id = prams.id;
      this.getData();
    }
    this.getParentList();
  },
  methods: {
    /**富文本编辑内容改变回调 */
    change(val) {
      this.addForm.content = val;
    },
    /**返回上一页 */
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    // 获取基础数据
    getData() {
      let data = {
        type: "GetGoodsCategory_detail",
        id: this.id,
      };
      let proc = "Proc_Admin_Category"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            let data = res.data[0];
            this.addForm.parentId = data.parent_id;
            this.addForm.title = data.title;
            this.addForm.sort = data.sort_id;
            this.addForm.content = decodeURIComponent(atob(data.content));
            this.isEditorLoad = true;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 获取父级列表
    getParentList() {
      let data = {
        type: "Pc_GetHelperType",
      };
      let proc = "Proc_Admin_Category"; //存储过程名
      let type = "ReturnBox";
      this.$requestSys({
        url:
          "coupon/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.parentList = this.changeArr(res.objList);
            this.addForm.parentId =
              this.addForm.parentId || this.parentList[0].value;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    //数组转化
    changeArr(list) {
      list = list.split("</option><option");
      list = list.map((item) => {
        let label = item
          .split("'>")[1]
          .split("</option>")[0]
          .replace(/&nbsp;/g, " ");
        let value = item.split("value='")[1].split("'>")[0];
        return { label, value };
      });
      return list;
    },
    /**提交表单 */
    submitForm() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let data = {
            type: "SaveGoodsCategory",
            proc: "Proc_Admin_Category",
            class_layer: this.addForm.parentId ? 2 : 1,
            parent_id: this.addForm.parentId,
            sort_id: this.addForm.sort,
            title: this.addForm.title,
            content: btoa(encodeURIComponent(this.addForm.content)),
            id: this.id,
          };
          this.$request({
            method: "post",
            url: "Article/SaveHelpCategory",
            data: data,
          })
            .then((res) => {
              if (res.flag) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.goBack();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
    /**重置表单 */
    resetForm() {
      this.$refs["addForm"].resetFields();
      this.addForm.parentId = this.parentList[0].value;
    },
  },
};
</script>

<style scoped>
.editDoc {
  width: 100%;
  height: 100%;
}
</style>
